import { render, staticRenderFns } from "./dataImportTable.vue?vue&type=template&id=47b29919&scoped=true&"
import script from "./dataImportTable.vue?vue&type=script&lang=js&"
export * from "./dataImportTable.vue?vue&type=script&lang=js&"
import style0 from "./dataImportTable.vue?vue&type=style&index=0&id=47b29919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b29919",
  null
  
)

export default component.exports